import styled from "styled-components";
import { styled as _styled } from "@mui/material/styles";
import { theme, size } from "../../../../helpers/theme";
import List from "@mui/material/List";
import ListItemText from "@mui/material/ListItemText/ListItemText";
import ListItemButton from "@mui/material/ListItemButton/ListItemButton";
import { ButtonBaseProps } from "@mui/material";


export const Container = styled.div`
  @media (max-width: ${size.laptop}) {
    display: none;
  }
`;

export const StyledList = _styled(List)({
    display: "flex",
    height: "80px",
    fontFamily: `${theme.fonts.interRegular}`,
    fontWeight: `${theme.fontWeight.normal}`,
});


export const StyledListItemTex = _styled(ListItemText)({
    whiteSpace: `nowrap`,
    "& .MuiTypography-root": {
        fontWeight: `${theme.fontWeight.normal}`,
        fontSize: "16px",
        lineHeight: "24px",
        fontFamily: `${theme.fonts.interRegular}`,
    },
});

export const StyledListItemButton = _styled(ListItemButton)<ButtonBaseProps>(({ }) => ({
    '&.active, &:hover, &.active:hover': {
        backgroundColor: 'transparent',
        '& span': {
            color: `${theme.colors.blue02_hover}`,

        }
    },
})); 